import React, { useEffect, useState } from "react";

// Util for setting cookies
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Util for getting cookies
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const AcceptCookies = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookie("cookiesAccepted")) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie("cookiesAccepted", "true", 365);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        background: "#333",
        color: "#fff",
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <span>
        This website uses cookies to ensure you get the best experience on our website.{" "}
        <a href="/privacy" style={{ color: "#4ECDC4" }}>Learn more</a>
      </span>
      <button
        onClick={handleAccept}
        style={{
          marginLeft: "1rem",
          background: "#4ECDC4",
          color: "#333",
          border: "none",
          borderRadius: "4px",
          padding: "0.5rem 1rem",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Accept
      </button>
    </div>
  );
};

export default AcceptCookies;

